// used for email validations
// returns 'true' or 'false'
export const isEmailValid = email => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$/.test(email);
